<template>
  <v-app>
    <v-main class="portal-bg">
      <div
        class="portal-wrapper d-flex flex-column align-center justify-center"
        style="min-height: 100vh"
      >
        <!-- Header branding -->
        <div
          class="portal-header primary d-flex align-center justify-center flex-column py-6 px-4 elevation-4 rounded-t-xl"
          style="width: 100%; max-width: 440px"
        >
          <v-icon color="white" size="36" class="mb-2"
            >mdi-lightning-bolt-circle</v-icon
          >
          <span class="white--text text-h6 font-weight-bold">Gali Energia</span>
          <span
            class="white--text text-caption text-uppercase letter-spacing-wide mt-1"
            style="opacity: 0.8"
            >Portal do Cliente</span
          >
        </div>

        <!-- Card de busca -->
        <v-card
          class="rounded-t-0 elevation-4"
          style="width: 100%; max-width: 440px"
        >
          <!-- Estado de Erro -->
          <v-card-text 
            v-if="errorToken" 
            class="pa-8 d-flex flex-column align-center text-center justify-center"
            style="min-height: 400px;"
          >
            <v-icon size="64" color="grey lighten-1">mdi-shield-lock-outline</v-icon>
            <h3 class="mt-4 grey--text text-h6 font-weight-bold">Acesso Inválido</h3>
            <p class="grey--text px-2 mt-2">
              O link de acesso utilizado é inválido ou já expirou. Por favor, solicite um novo link ao suporte da Gali Energia.
            </p>
            <div class="text-center mt-5" style="position: absolute; bottom: 32px;">
              <span class="caption grey--text">
                © {{ anoAtual }} Gali Energia – Pós-Vendas
              </span>
            </div>
          </v-card-text>

          <!-- Formulário -->
          <v-card-text class="pa-8" v-else>
            <h2 class="text-h6 font-weight-bold primary--text mb-2">
              Acesso ao Ticket {{ idTicket }}
            </h2>
            <p class="body-2 grey--text text--darken-1 mb-6">
              Informe a senha do ticket e seu email para visualizar as
              interações e arquivos do seu atendimento.
            </p>

            <v-form @submit.prevent="buscar" ref="form">
              <v-text-field
                v-model="senha"
                label="Senha do Ticket"
                prepend-inner-icon="mdi-lock-outline"
                outlined
                id="senha"
                dense
                :rules="[(v) => !!v || 'Informe a senha do ticket']"
                :error-messages="erroSenha"
                placeholder="Ex: A3K7F"
                class="mb-2"
                :type="mostrarSenha ? 'text' : 'password'"
                :append-icon="mostrarSenha ? 'mdi-eye-off' : 'mdi-eye'"
                @click:append="mostrarSenha = !mostrarSenha"
                @input="erroSenha = ''"
                style="letter-spacing: 0.15em"
              />

              <v-text-field
                v-model="email"
                label="Email"
                id="email"
                prepend-inner-icon="mdi-email"
                outlined
                dense
                :rules="[(v) => !!v || 'Informe o email']"
                :error-messages="erroEmail"
                placeholder="Ex: cliente@galienergia.com.br"
                class="mb-2"
                @input="erroEmail = ''"
              />
              <v-btn
                color="primary"
                type="submit"
                block
                large
                :loading="carregando"
                class="mt-2 elevation-2"
              >
                <v-icon left>mdi-arrow-right-circle</v-icon>
                Acessar Ticket
              </v-btn>
            </v-form>

            <div class="text-center mt-5">
              <span class="caption grey--text">
                © {{ anoAtual }} Gali Energia – Pós-Vendas
              </span>
            </div>
          </v-card-text>
        </v-card>
      </div>
    </v-main>
  </v-app>
</template>

<script>
import API from "@/api/API";
import jwt from "jsonwebtoken";

export default {
  name: "PortalBuscaForm",
  data: () => ({
    idTicket: "",
    senha: "",
    cliente: "",
    email: "",
    erroEmail: [],
    mostrarSenha: false,
    carregando: false,
    erroTicket: "",
    erroSenha: "",
    token: "",
    errorToken: false,
  }),
  created() {
    this.token = this.$route.params?.jwt;
    if (this.token) {
      try {
        const decoded = jwt.decode(this.token);
        if (decoded?.ticketId) this.idTicket = decoded.ticketId;
        if (decoded.origem == "progali") this.loginProgali(decoded);
      } catch (e) {
        console.warn("JWT inválido na rota", e);
        this.errorToken = true;
      }
    } else {
      this.errorToken = true;
    }
  },
  computed: {
    anoAtual() {
      return new Date().getFullYear();
    },
  },
  methods: {
    async loginProgali(decodedToken) {
      try {
        this.carregando = true;
        console.log("Login via Progali para ticket", decodedToken);
        await API.acessarPortalTicket(decodedToken.ticketId, "", this.token, decodedToken.email);
        sessionStorage.setItem("emailUsuario", decodedToken.email);
        sessionStorage.setItem("token", this.token);
        this.$router.push({
          name: "PortalTicket",
          params: { id: decodedToken.ticketId },
        });
      } catch (e) {
        console.error("Erro ao acessar o portal do ticket:", e);
        this.errorToken = true;
      } finally {
        this.carregando = false;
      }
    },
    async buscar() {
      if (!this.$refs.form.validate()) return;
      this.carregando = true;
      this.erroTicket = "";
      this.erroSenha = "";

      try {
        const id = this.idTicket.trim().toUpperCase();
        const senha = this.senha.trim().toUpperCase();
        await API.acessarPortalTicket(id, senha, this.token, this.email.trim());
        sessionStorage.setItem("emailUsuario", this.email.trim());
        sessionStorage.setItem("token", this.token);
        this.$router.push({ name: "PortalTicket", params: { id } });
      } catch (e) {
        if (e.status === 401) {
          this.erroSenha = "Senha incorreta. Verifique e tente novamente.";
        } else {
          this.erroTicket = "Ticket não encontrado. Verifique o ID informado.";
        }
      } finally {
        this.carregando = false;
      }
    },
  },
};
</script>

<style scoped>
.portal-bg {
  background-color: #f5f5f5;
}
.letter-spacing-wide {
  letter-spacing: 0.12em;
}
</style>
